namespace Matrix.Data {
    export interface ModelTargetForm {
        ModelCode: Serenity.StringEditor;
        Level: Serenity.IntegerEditor;
        FullName1: Serenity.StringEditor;
        Code1: Serenity.StringEditor;
        Name1: Serenity.StringEditor;
        FullName2: Serenity.StringEditor;
        Code2: Serenity.StringEditor;
        Name2: Serenity.StringEditor;
        FullName3: Serenity.StringEditor;
        Code3: Serenity.StringEditor;
        Name3: Serenity.StringEditor;
        FullName4: Serenity.StringEditor;
        Code4: Serenity.StringEditor;
        Name4: Serenity.StringEditor;
        FullName5: Serenity.StringEditor;
        Code5: Serenity.StringEditor;
        Name5: Serenity.StringEditor;
        FullName6: Serenity.StringEditor;
        Code6: Serenity.StringEditor;
        Name6: Serenity.StringEditor;
        FullName7: Serenity.StringEditor;
        Code7: Serenity.StringEditor;
        Name7: Serenity.StringEditor;
        FullName8: Serenity.StringEditor;
        Code8: Serenity.StringEditor;
        Name8: Serenity.StringEditor;
        FullName9: Serenity.StringEditor;
        Code9: Serenity.StringEditor;
        Name9: Serenity.StringEditor;
        FullName10: Serenity.StringEditor;
        Code10: Serenity.StringEditor;
        Name10: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        TargetCode: Serenity.StringEditor;
        SiblingDisplayOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ModelTargetForm extends Serenity.PrefixedContext {
        static formKey = 'Data.ModelTarget';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ModelTargetForm.init)  {
                ModelTargetForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(ModelTargetForm, [
                    'ModelCode', w0,
                    'Level', w1,
                    'FullName1', w0,
                    'Code1', w0,
                    'Name1', w0,
                    'FullName2', w0,
                    'Code2', w0,
                    'Name2', w0,
                    'FullName3', w0,
                    'Code3', w0,
                    'Name3', w0,
                    'FullName4', w0,
                    'Code4', w0,
                    'Name4', w0,
                    'FullName5', w0,
                    'Code5', w0,
                    'Name5', w0,
                    'FullName6', w0,
                    'Code6', w0,
                    'Name6', w0,
                    'FullName7', w0,
                    'Code7', w0,
                    'Name7', w0,
                    'FullName8', w0,
                    'Code8', w0,
                    'Name8', w0,
                    'FullName9', w0,
                    'Code9', w0,
                    'Name9', w0,
                    'FullName10', w0,
                    'Code10', w0,
                    'Name10', w0,
                    'Description', w0,
                    'TargetCode', w0,
                    'SiblingDisplayOrder', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
